import createRestfulModule from './restful-module'

export default createRestfulModule({

  state: {
    path: 'activities', // 资源路径
    defaultRels: ['companies'], // 默认需要的关联数据
  },

})
